export default __webpack_public_path__ + "static/media/CV.f0d0e8a0.pdf";